import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { useContext, useMemo } from "react";

import { Badge } from "../badge";
import { OverflowText } from "../text";
import { NavbarItem } from "./item.navbar";
import { NavbarContext } from "./navbar";

import "./profile-item.navbar.scss";
import { ROLE_NAMES, ROLES } from "@src/constants";

export const ProfileItemNavbar = ({ user, ...itemNavbarConfig }) => {
  const { isExpanded } = useContext(NavbarContext);

  const itemContent = useMemo(() => {
    const fullName = `${user?.firstName} ${user?.lastName}`.trim();
    return isExpanded ? (
      <>
        <FontAwesomeIcon
          className="profile-icon"
          icon={["fasr", "circle-user"]}
        />
        <div className="profile-info">
          <OverflowText value={fullName} />
          <Badge>{ROLE_NAMES[ROLES.student].toUpperCase()}</Badge>
        </div>
      </>
    ) : undefined;
  }, [isExpanded]);

  return (
    <NavbarItem
      className={"profile-item-navbar"}
      title={user?.firstName}
      icon="circle-user"
      {...itemNavbarConfig}
    >
      {itemContent}
    </NavbarItem>
  );
};

ProfileItemNavbar.displayName = "Profile Item Navbar";

ProfileItemNavbar.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
};
